import { useState } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function CategoryPicker({ categories, value, onChange }) {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="resource-form-categories">
      {categories.map((c) => {
        const on = value.includes(c.key);
        return (
          <button key={c.key} type="button" onClick={() => toggle(c.key)} aria-pressed={on}
                  data-testid={`resource-form-category-${c.key}`}
                  className={`rounded-full border px-2.5 py-1 text-xs transition-colors ${
                    on ? "border-zinc-900 bg-zinc-900 text-white" : "border-zinc-300 bg-white text-zinc-700 hover:bg-zinc-50"}`}>
            {c.label}
          </button>
        );
      })}
    </div>
  );
}

export function ListInput({ label, value, onChange, placeholder, suggestions = [], testId }) {
  const [text, setText] = useState(value.join(", "));
  const listId = `${testId}-options`;
  return (
    <div>
      <Label className="text-xs">{label}</Label>
      <Input className="mt-1" value={text} placeholder={placeholder} list={listId} data-testid={testId}
             onChange={(e) => {
               setText(e.target.value);
               onChange(e.target.value.split(",").map((s) => s.trim()).filter(Boolean));
             }} />
      <datalist id={listId}>{suggestions.map((s) => <option key={s} value={s} />)}</datalist>
    </div>
  );
}

export function PersonSelect({ label, value, onChange, people, allowNone, testId }) {
  return (
    <div>
      <Label className="text-xs">{label}</Label>
      <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? null : v)}>
        <SelectTrigger className="mt-1" data-testid={testId}><SelectValue placeholder="Choose…" /></SelectTrigger>
        <SelectContent>
          {allowNone && <SelectItem value="none">Any clinical approver</SelectItem>}
          {people.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}

export function LinkPicker({ meta, links, onChange, required }) {
  const pick = (kind, refId) => {
    const rest = links.filter((l) => l.kind !== kind);
    onChange(refId && refId !== "none" ? [...rest, { kind, ref_id: refId }] : rest);
  };
  const current = (kind) => links.find((l) => l.kind === kind)?.ref_id || "none";
  const rows = [
    ["checkin_template", "Progress Review template", meta.templates],
    ["outcome_measure", "Outcome measure", meta.measures],
  ].filter(([kind]) => !required || required === kind);
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {rows.map(([kind, label, options]) => (
        <div key={kind}>
          <Label className="text-xs">{label}{required ? " (required)" : " (optional link)"}</Label>
          <Select value={current(kind)} onValueChange={(v) => pick(kind, v)}>
            <SelectTrigger className="mt-1" data-testid={`resource-form-link-${kind}`}><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">None</SelectItem>
              {(options || []).map((o) => <SelectItem key={o.id} value={o.id}>{o.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      ))}
    </div>
  );
}
